module.exports = __webpack_public_path__ + "static/media/digital-clock-beep.1398b009.wav";